import './HomePage.scss';
import html from "../../img/html.png";
import css from "../../img/css.png";
import js from "../../img/javascript.png";
import sass from "../../img/sass.png";
import git from "../../img/git.png";
import github from "../../img/github.png";
import react from "../../img/react.png";


const HomePage = () => {
    return (
        <div className='homepage'>
            <ul className="homepage__technologies">
                <li className="homepage__item"><img src={html} alt="html" /></li>
                <li className="homepage__item"><img src={css} alt="css" /></li>
                <li className="homepage__item"><img src={js} alt="javascript"/></li>
                <li className="homepage__item"><img src={sass} alt="sass"/></li>
                <li className="homepage__item"><img src={git} alt="git"/></li>
                <li className="homepage__item"><img src={github} alt="github"/></li>
                <li className="homepage__item"><img src={react} alt="react"/></li>
            </ul>
            <div className="homepage__main">
                <span className='homepage__main-span'>Меня зовут Никита Шмидт</span>
                <h1 className="homepage__main-title">Hi, i Front-End Developer</h1>
                <div className="homepage__btns">
                    <a href='https://nikitashmidt.github.io/#about' className='homepage__btns-link' >About me</a>
                    <a href='https://nikitashmidt.github.io/#portfolio' className='homepage__btns-link' > Portfolio</a>
                    <a href='https://nikitashmidt.github.io/#contacts' className='homepage__btns-link' > Contacts </a>
                 </div>
            </div>
           
        </div>
    );
};

export default HomePage;